// extracted by mini-css-extract-plugin
export default {"verifiedReviewsBox":"verifiedReviewsBox--mp-TbBiL","text":"text--mp-yeVFN","icon":"icon--mp-Mqe9E"};